function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "_clip1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1138.9,819.526C1140.15,811.991 1107.56,785.324 1102.08,768.857C1097.99,756.589 1060.39,639.682 1061.87,630.797C1062.63,626.208 1095.6,543.845 1069.11,471.707C1044.32,404.215 960,346.499 960,346.499C960,346.499 798.301,342.797 770.908,370.931C743.515,399.065 733.89,416.833 730.188,431.641C726.487,446.448 711.943,486.686 708.153,501.09C704.362,515.495 722.797,529.795 722.418,540C722.038,550.205 700.432,578.635 697.399,584.7C694.367,590.765 671.544,623.139 675.414,634.357C686.465,666.397 713.699,649.899 718.627,660.513C723.555,671.126 729.241,684.773 729.241,684.773L736.822,701.451C736.822,701.451 732.273,703.347 734.548,709.033C736.822,714.719 744.403,775.369 744.403,775.369L783.826,789.773L867.978,814.792C867.978,814.792 874.043,829.196 878.213,834.882C882.383,840.568 886.931,841.705 891.48,849.286C896.029,856.868 910.4,903.364 923.825,908.669C954.341,920.728 1041,930.48 1076.84,915.623C1112.07,901.023 1134.86,843.923 1138.9,819.526Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "_clip2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Eye1",
  d: "M763.78,537.889C763.314,545.342 772.63,555.279 772.63,555.279C778.896,557.024 787.284,553.097 797.162,545.187L768.282,528.729C768.282,528.729 764.248,530.393 763.78,537.889Z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Pupil",
  transform: "matrix(0.556818,0,0,1,340.681,0.308328)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 763.724,
  cy: 538.237,
  rx: 2.239,
  ry: 4.782
}));

function SvgSandersFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 724 821",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,498.938,233.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Face",
    transform: "matrix(1,0,0,1,-1173.91,-484.051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1139.1,802.789C1160.62,804.53 1168.43,814.722 1187.07,834.763C1199.02,847.607 1274.65,849.428 1308.03,875.635C1381.25,933.12 1398.62,1068.86 1398.62,1068.86L822.033,1070.64C822.033,1070.64 853.533,966.095 859.071,953.126C871.05,925.076 900.315,867.4 900.315,867.4C900.315,867.4 923.445,906.993 934.059,908.13C944.673,909.267 1083.36,833.695 1120.92,822.381C1123,821.754 1132.15,802.228 1139.1,802.789Z",
    style: {
      fill: "rgb(42,42,50)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "RightBrow",
    d: "M716.902,524.636L709.139,504.141C709.139,504.141 703.728,509.986 706.189,516.251C709.276,524.114 716.902,524.636 716.902,524.636Z",
    style: {
      fill: "rgb(27,17,12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.9,819.526C1140.15,811.991 1107.56,785.324 1102.08,768.857C1097.99,756.589 1060.39,639.682 1061.87,630.797C1062.63,626.208 1095.6,543.845 1069.11,471.707C1044.32,404.215 960,346.499 960,346.499C960,346.499 798.301,342.797 770.908,370.931C743.515,399.065 733.89,416.833 730.188,431.641C726.487,446.448 711.943,486.686 708.153,501.09C704.362,515.495 722.797,529.795 722.418,540C722.038,550.205 700.432,578.635 697.399,584.7C694.367,590.765 671.544,623.139 675.414,634.357C686.465,666.397 713.699,649.899 718.627,660.513C723.555,671.126 729.241,684.773 729.241,684.773L736.822,701.451C736.822,701.451 732.273,703.347 734.548,709.033C736.822,714.719 744.403,775.369 744.403,775.369L783.826,789.773L867.978,814.792C867.978,814.792 874.043,829.196 878.213,834.882C882.383,840.568 886.931,841.705 891.48,849.286C896.029,856.868 910.4,903.364 923.825,908.669C954.341,920.728 1041,930.48 1076.84,915.623C1112.07,901.023 1134.86,843.923 1138.9,819.526Z",
    style: {
      fill: "rgb(197,156,124)"
    }
  }), _ref2, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M733.887,711.198C733.887,711.198 744.822,710.929 750.414,710.659C755.081,710.434 764.176,709.118 766.517,706.574C768.857,704.03 731.055,696.856 731.055,696.856L733.887,711.198Z",
    style: {
      fill: "rgb(163,96,94)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Eye",
    d: "M763.78,537.889C763.314,545.342 772.63,555.279 772.63,555.279C778.896,557.024 787.284,553.097 797.162,545.187L768.282,528.729C768.282,528.729 764.248,530.393 763.78,537.889Z",
    style: {
      fill: "rgb(206 199 199)"
    }
  }), _ref3, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iris",
    transform: "matrix(0.911679,0,0,0.911679,683.612,261.517)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 763.724,
    cy: 538.237,
    rx: 10,
    ry: 13,
    style: {
      fill: "rgb(91,49,26)"
    }
  })), _ref4)), /*#__PURE__*/React.createElement("path", {
    d: "M1061.52,712.644C1068.61,726.491 1092.03,727.333 1098.67,709.801C1105.3,692.269 1096.96,642.991 1106.44,617.878C1115.91,592.765 1150.23,507.832 1141.09,447.773C1134.59,405.065 1092.7,300.886 1012.62,280.985C932.542,261.084 814.234,207.021 701.893,319.361C690.504,330.751 670.206,381.982 691.434,408.609C701.075,420.702 720.251,432.184 730.908,428.985C735.295,414.464 742.052,404.627 751.141,393.135C761.711,379.771 767.818,372.414 774.698,367.789C806.445,346.449 882.789,356.324 882.789,356.324C882.789,356.324 842.514,418.396 854.36,467.2C866.205,516.005 912.584,593.396 894.161,631.319C880.895,658.628 869.102,671.364 814.306,693.407C795.881,700.819 805.967,735.428 796.638,736.05C776.763,737.378 803.186,716.799 767.175,689.426C736.994,666.486 737.904,653.032 726.532,656.349C715.161,659.666 710.96,671.078 710.96,680.081C710.96,692.344 732.422,705.398 754.087,703.601C763.127,702.851 783.237,729.857 778.972,736.965C774.708,744.072 764.806,760.501 754.381,757.658C743.957,754.815 760.941,713.637 735.864,714.791C729.217,715.097 731.808,766.032 734.65,786.88C737.493,807.729 766.376,841.978 787.852,838.715C879.443,824.797 943.587,782.319 960,728.136C977.759,669.509 897.29,559.122 968.553,540C1057.72,516.072 1045.77,681.88 1061.52,712.644Z",
    style: {
      fill: "rgb(27,17,12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.554,540C989.554,540 1015.95,519.65 1038.93,527.103C1061.91,534.555 1070.29,563.59 1068.43,577.719C1066.57,591.848 1054.45,621.659 1041.88,632.683C1029.3,643.706 994.057,678.641 973.252,668.704C952.446,658.767 967.196,631.319 967.196,631.319L989.554,540Z",
    style: {
      fill: "rgb(197,156,124)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "LeftBrow",
    d: "M755.991,481.447C773.086,482.586 829.65,532.49 828.291,535.207C826.933,537.924 765.306,501.631 755.991,503.572C746.675,505.512 724.847,525.086 721.935,523.34C719.024,521.593 710.485,506.871 713.202,500.66C715.919,494.45 741.435,480.476 755.991,481.447Z",
    style: {
      fill: "rgb(27,17,12)"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandersFace);
export default __webpack_public_path__ + "static/media/sanders_face.04958606.svg";
export { ForwardRef as ReactComponent };